import useVuelidate from '@vuelidate/core';
import type { FlowOperatorMetadata, ValidationResult } from '@/types/flow-types';
import { TypeCampaignEnum } from '@/types';
import type { ShopsTags } from '@/types/generated-types/graphql';
import { includesValuesValidator, requiredWithMessage } from '@/helpers/CustomValidator';
import Form from './Form.vue';

export interface TagData {
  autocomp_tag: ShopsTags[];
  multiplebox_type: number;
}

export const createDefaultData = (overrides: Partial<TagData> = {}): TagData => ({
  autocomp_tag: [],
  multiplebox_type: 0,
  ...overrides,
});

export const Tag: FlowOperatorMetadata<TagData> = {
  id: 'boxtag',
  kind: 'action',
  label: 'flows.operators.tag.label',
  icon: 'fa-tag',
  hasConfiguration: true,

  availableIn: [TypeCampaignEnum.AUTOMATION, TypeCampaignEnum.BULK],

  incompatibilities: {
    automation: {
      nextOperators: ['boxabandonpanier', 'boxperiodiclaunching'],
    },
    bulk: {
      nextOperators: ['boxabandonpanier', 'boxperiodiclaunching', 'boxchoosebulklist', 'boxaudiencesetup'],
    },
  },

  Form,

  defaultData: createDefaultData,

  outputs(data: TagData): number {
    return 1;
  },

  async validate(data: TagData): Promise<ValidationResult> {
    const normalizedData = {
      ...data,
      multiplebox_type: Number(data.multiplebox_type),
    };

    const rules = {
      autocomp_tag: {
        requiredWithMessage: requiredWithMessage(),
      },
      multiplebox_type: {
        required: requiredWithMessage(),
        includesValuesValidator: includesValuesValidator([0, 1]),
      },
    };

    const v$ = useVuelidate(rules, normalizedData);
    const success = await v$.value.$validate();

    return {
      success,
      validate: v$,
    };
  },

  beforeInsert(data: TagData): TagData {
    let dataToReturn: TagData = data;
    if (data.autocomp_tag.length > 0) {
      const formatData = data.autocomp_tag.reduce((accumulator: any, currentValue) => {
        accumulator[currentValue.id_shop_tag] = currentValue.tag;
        return accumulator;
      }, {});
      dataToReturn = {
        ...dataToReturn,
        autocomp_tag: formatData as any,
      };
    }
    return dataToReturn;
  },
};

export default Tag;
